const IconLogout = (): JSX.Element => {
  return (
    <>
      <g clipPath="url(#clip0_17030_52102)">
        <path
          d="M13.499 3L13.6035 3.00488C13.8437 3.02675 14.0631 3.12245 14.2246 3.26855C14.4075 3.43401 14.4996 3.64716 14.5 3.85742V5.39258H13.5V4H4.5V20H13.5V18.5H14.5V20.1426L14.4951 20.2207C14.4749 20.4048 14.3848 20.5865 14.2246 20.7314C14.04 20.8984 13.7795 20.9997 13.499 21H4.50098C4.22054 20.9997 3.96001 20.8984 3.77539 20.7314C3.59252 20.566 3.50037 20.3528 3.5 20.1426V3.85742L3.50488 3.7793C3.5251 3.59517 3.61518 3.41351 3.77539 3.26855C3.93694 3.12245 4.1563 3.02675 4.39648 3.00488L4.50098 3H13.499Z"
          stroke="currentColor"
        />
        <path
          d="M20.293 12L16.5 15.793L16.1465 15.4395L19.3359 12.25H8V11.75H19.3359L16.1465 8.56055L16.5 8.20703L20.293 12Z"
          stroke="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_17030_52102">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </>
  );
};

export default IconLogout;
